import { render, staticRenderFns } from "./BackupFilesIndexModal.vue?vue&type=template&id=5f19bf3a&scoped=true&"
import script from "./BackupFilesIndexModal.vue?vue&type=script&lang=ts&"
export * from "./BackupFilesIndexModal.vue?vue&type=script&lang=ts&"
import style0 from "./BackupFilesIndexModal.vue?vue&type=style&index=0&id=5f19bf3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f19bf3a",
  null
  
)

export default component.exports